import { render, staticRenderFns } from "./Weekdays.vue?vue&type=template&id=6f2e8b84&scoped=true&"
import script from "./Weekdays.vue?vue&type=script&lang=js&"
export * from "./Weekdays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e8b84",
  null
  
)

export default component.exports